module.exports = __webpack_public_path__ + "img/room21_cartabea.08dd5cbe.png";